import { render, staticRenderFns } from "./DashKnowledge.vue?vue&type=template&id=3e8cb591&scoped=true&"
import script from "./DashKnowledge.vue?vue&type=script&lang=js&"
export * from "./DashKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./DashKnowledge.vue?vue&type=style&index=0&id=3e8cb591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8cb591",
  null
  
)

export default component.exports